import React, {useState, useEffect} from 'react'

import classes from './PopupMentionsLegales.module.css'
import PopupsManager from 'react-sdk/PopupsManager';
import Texts from 'react-sdk/Texts';
import Popup from '@/components/shared/Popup/Popup';
import Button from '@/components/shared/Button/Button';
import { POPUPS } from '@/js/AppState';

const PopupMentionsLegales = () => {

  return (
    <Popup className={classes.PopupMentionsLegales}>
      <div className={classes.content}>
        <h2>{Texts.get("mentions-legales-title")}</h2>
        <div className={classes.text} dangerouslySetInnerHTML={{__html: Texts.get("mentions-legales-text")}} />

        <div className={classes.btn_ctnr}>
          <Button onClick={() => PopupsManager.close(POPUPS.MENTIONS_LEGALES)} > Valider</Button>
        </div>
      </div>
   </Popup>
  );
};

export default PopupMentionsLegales;
